/* eslint-disable quotes */
/* eslint-disable react/display-name */
/* eslint-disable no-prototype-builtins */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useRef, Fragment, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  getAuthSession,
  getObjectLength,
  hrefPattern,
  hrefValue,
} from "../Helpers/common";
import ChatBoardIncoming from "./chatboardIncoming";
import ChatBoardOutgoing from "./chatboardOutgoing";
import {
  _jumpToSpecificChatData,
  _sendLoadMoreChatData,
  _sendPinnedChatMessage,
  _unreadMessageCountUpdate,
} from "../../SocketIo";
import {
  setActiveThreadChat,
  setChatboardSelectedTab,
  setChatMessage,
  setImagePreviewOpen,
  setIsChatHistoryEnableOnce,
  setIsFetchingChatHistory,
  setIsScrollingUp,
  setJumpTargetMessage,
  setJumpTargetMessageThread,
  setLoaderActiveData,
  setReplyMessage,
  setUnreadChatMessage,
} from "../redux/chatSlice";
import ImagePreview from "../models/ImagePreview";
import {
  checkIsAttachmentsUploaded,
  getChatMessageByGroup,
  getMsgListCorrespondenceToRoom,
  updateChatRoom,
} from "../Helpers/chatCommon";
import CustomDropdown from "../customComponent/customDropdown";
import { getData } from "../util/indexedDB";
import PinnedMessages from "../models/PinnedMessages";
import ChatboardFiles from "./chatboardFiles";
import ChatboardSearch from "./chatboardSearch";
import CustomChatLoader from "../customComponent/customChatLoader";
import ProgressBar from "./progressBar";
import { DownChevronIcon } from "../../assets/icons/svg";
import ChatboardThread from "./chatboardThread";

const ChatBoardBody = () => {
  const dispatch = useDispatch();
  const { chat, authUserDetail } = useSelector((state) => state);

  const { authSessionUser } = authUserDetail || {};
  const {
    chatMessage,
    progress,
    imagePreviewOpen,
    loaderActiveData,
    attendeeData,
    searchChatData,
    deletedMessageIds,
    isFetchingChatHistory,
    chatRoom,
    isChatHistoryEnableOnce,
    isScrollingUp,
    replyMessage,
    unreadChatMessage,
    chatboardSelectedTab,
    jumpTargetMessage,
  } = chat || {};

  const authSession = getAuthSession();
  const chatFilterRef = useRef([]);
  const lastElement = useRef(null);
  const chatFeed = useRef(null);
  const [newChatMessage, setNewChatMessage] = useState([]);
  const [selectedJumpId, setSelectedJumpId] = useState(null);
  const [chatMessageByGroup, setChatMessageByGroup] = useState([]);
  const [beginningMessage, setBeginningMessage] = useState(true);
  const [stopScrollBottom, setStopScrollBottom] = useState(false);
  const [lastScrollHeight, SetLastScrollHeight] = useState("");
  const [messageEditId, setMessageEditId] = useState("");
  const [disableScroll, setDisableScroll] = useState(false);
  const [moreActionEnableId, setMoreActionEnableId] = useState("");
  const [isMessageUpdateFromJump, setIsMessageFromJump] = useState(false);
  const [isOpenDropdown, setIsOpenDropdown] = useState("");

  // ---------------------Date-----------------
  const todayDate = moment(Date.now()).format("MMM DD YYYY");
  let username = attendeeData.name;
  let type = "private";
  let receiverID = attendeeData?.user_id;
  let companyID = attendeeData.company_id;
  let senderID = authSession.user_unique_key;

  if (attendeeData.type == "group") {
    username = attendeeData.username;
    type = "group";
    receiverID = attendeeData.groupId;
    companyID = authSession.company_unique_key;
  }

  useEffect(() => {
    if (Object.keys(attendeeData).length > 0) {
      updateChatRoom(type, senderID, receiverID);
    }
  }, [attendeeData]);

  let incomingUserObj = attendeeData;
  let outgoingUserObj = authSessionUser;

  // socket code start//

  useEffect(() => {
    const getChat = async () => {
      if (chatRoom) {
        const chatMessagesData = await getData(chatRoom);
        if (chatMessagesData && chatMessagesData?.list) {
          dispatch(setChatMessage(chatMessagesData?.list));
        } else {
          getMsgListCorrespondenceToRoom();
        }
      }
    };

    getChat();
  }, [chatRoom]);

  useEffect(() => {
    if (getObjectLength(replyMessage)) {
      const updatedReplyMessage = chatMessage.filter(
        (item) => item.id == replyMessage.id,
      );
      if (updatedReplyMessage.length > 0) {
        dispatch(setReplyMessage(updatedReplyMessage[0]));
      }
    }
    setNewChatMessage(chatMessage);
  }, [chatMessage]);

  useEffect(() => {
    if (searchChatData) {
      setBeginningMessage(false);
    } else {
      setBeginningMessage(true);
    }
  }, [searchChatData]);

  useEffect(() => {
    dispatch(setLoaderActiveData(false));
  }, [newChatMessage]);

  useEffect(() => {
    if (newChatMessage) {
      getChatMessageByGroup(newChatMessage).then((data) => {
        setChatMessageByGroup(data);
      });
    }
  }, [newChatMessage, attendeeData]);

  useEffect(() => {
    let lastScrollTop = 0;
    const el = document.getElementById("chat-feed");
    if (el) {
      el.onscroll = () => {
        if (el.scrollTop < lastScrollTop) {
          dispatch(setIsScrollingUp(true));
        }
        lastScrollTop = el.scrollTop <= 0 ? 0 : el.scrollTop;
        if (el.scrollTop + el.offsetHeight >= el.scrollHeight - 3) {
          dispatch(setIsScrollingUp(false));
        }
      };
    }
    if (stopScrollBottom === false) {
      if (!isChatHistoryEnableOnce && !isScrollingUp) {
        scrollToBottom();
      }
    } else {
      if (el && stopScrollBottom === false) {
        const NewScrollHeight = el.scrollHeight;
        const difference = NewScrollHeight - lastScrollHeight;
        el.scrollTop = difference;
      }
      setTimeout(() => {
        setStopScrollBottom(false);
      }, 100);
    }
  }, [chatMessageByGroup]);

  useEffect(() => {
    checkIsAttachmentsUploaded();
  }, [newChatMessage]);

  useEffect(() => {
    if (!isFetchingChatHistory) return;
    fetchMoreListItems();
  }, [isFetchingChatHistory]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      chatFilterRef?.current?.forEach((divRef) => {
        if (divRef && !divRef?.current?.contains(event?.target)) {
          setSelectedJumpId("");
          setDisableScroll(false);
          setIsOpenDropdown("");
        }
      });
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if (isMessageUpdateFromJump) {
      setTimeout(() => {
        const elementId = chatMessage[chatMessage.length - 1];
        let element = document.getElementById(elementId?.id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          setIsMessageFromJump(false);
        }
      }, 200);
    }
  }, [chatMessage]);

  useEffect(() => {
    if (chatboardSelectedTab === "messages" && jumpTargetMessage) {
      const tryScroll = () => {
        const el = document.querySelector(
          `.chat_row[id='${jumpTargetMessage.id}']`,
        );
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.classList.add("pin-highlight");
          el.focus({ preventScroll: true });
          setTimeout(() => {
            el.classList.remove("pin-highlight");
          }, 2000);
          return true;
        }
        return false;
      };

      if (!tryScroll()) {
        dispatch(setLoaderActiveData(true));
        _sendLoadMoreChatData({
          company_id: companyID,
          documentID: chatRoom,
          user_id: senderID,
          timestamp: jumpTargetMessage.timestamp + 1,
        });
        setTimeout(() => {
          tryScroll();
        }, 1200);
      }
      dispatch(setJumpTargetMessage(null));
    }
  }, [chatboardSelectedTab, jumpTargetMessage]);

  useEffect(() => {
    if (chatboardSelectedTab === "messages" && !jumpTargetMessage) {
      scrollToBottom();
    }
  }, [chatboardSelectedTab]);

  const scrollToBottom = () => {
    lastElement.current?.scrollIntoView({ behavior: "smooth" });
    const el = document.getElementById("chat-feed");
    if (el) {
      el.scrollTop = el?.scrollHeight;
    }
  };

  const fetchMoreListItems = () => {
    setTimeout(() => {
      const payloadData = {
        company_id: companyID,
        documentID: chatMessage[chatMessage.length - 1].documentID,
        timestamp: chatMessage[chatMessage.length - 1].timestamp,
        user_id: senderID,
      };
      _sendLoadMoreChatData(payloadData);
    }, 2000);
  };

  const handleScroll = (e) => {
    let element = e.target;
    if (
      element.scrollTop === 0 &&
      chatMessageByGroup.length > 0 &&
      searchChatData === ""
    ) {
      dispatch(setIsFetchingChatHistory(true));
      dispatch(setIsChatHistoryEnableOnce(true));
      setStopScrollBottom(true);
      SetLastScrollHeight(element?.scrollHeight ?? 0);
    }
    const el = document.getElementById("chat-feed");
    if (el) {
      const { scrollTop, scrollHeight, clientHeight } = el;
      if (scrollTop + clientHeight === scrollHeight) {
        dispatch(setIsChatHistoryEnableOnce(false));

        const prevChatMessage = [...unreadChatMessage];
        const msgIndex = prevChatMessage.findIndex(
          (obj) =>
            obj.user_id ===
            (type === "private"
              ? attendeeData?.user_id
              : attendeeData?.groupId),
        );
        if (msgIndex !== -1) {
          const msgElement = prevChatMessage[msgIndex];
          if (msgElement.count !== 0) {
            prevChatMessage[msgIndex] = {
              company_id: companyID,
              logged_user_id: senderID,
              user_id: msgElement?.user_id,
              count: 0,
              timestamp: msgElement.timestamp,
              notification_sound: msgElement?.notification_sound ?? true,
              group_mute: msgElement?.group_mute ?? false,
            };
            const newObj = {
              company_id: companyID,
              logged_user_id: senderID,
              user_id: msgElement?.user_id,
              count: 0,
              timestamp: msgElement.timestamp,
              notification_sound: msgElement?.notification_sound ?? true,
              group_mute: msgElement?.group_mute ?? false,
            };
            _unreadMessageCountUpdate(newObj);
            dispatch(setUnreadChatMessage(prevChatMessage));
          }
        }
      }
    }
  };

  const editMessageHandler = (id) => {
    const element1 = document.getElementById(id)?.getBoundingClientRect()?.top;
    const element2 = document
      .getElementById("text")
      ?.getBoundingClientRect()?.top;
    let totalCal = element2 - element1;
    totalCal < 96 ? console.log("Yes") : console.log("No");
    setMessageEditId(id);
    setMoreActionEnableId("");
  };

  const moreActionHandler = (id) => {
    setMoreActionEnableId(moreActionEnableId === id ? "" : id);
  };

  const handleDisableScroll = (e, rowId) => {
    window.onload = handleMouseMove(e);
    let element = document.getElementById(rowId);
    element?.addEventListener("click", handleMouseMove);

    function handleMouseMove(event) {
      let textArea = document
        .getElementById("text")
        ?.getBoundingClientRect()?.top;
      let mouseY = event.pageY;
      let totalCal = Math.floor(textArea) - Number(mouseY);
      totalCal < 210
        ? setIsOpenDropdown("position-bottom")
        : setIsOpenDropdown("");
    }
    if (selectedJumpId === rowId) {
      setSelectedJumpId("");
      setDisableScroll(false);
      element?.removeEventListener("click", handleMouseMove);
    } else {
      setSelectedJumpId(rowId);
      setDisableScroll(true);
    }
  };

  const replyHandler = (replyData) => {
    dispatch(setReplyMessage(replyData));
  };

  const handleImagePreviewClose = () => {
    dispatch(setImagePreviewOpen(false));
  };

  const handleChatFilterByDate = async (day) => {
    const payloadData = {
      company_id: companyID,
      documentID: chatMessage[chatMessage.length - 1].documentID,
      days: day,
    };

    const result = await _jumpToSpecificChatData(payloadData);
    if (result.length > 0) {
      setSelectedJumpId("");
      setDisableScroll(false);
      setIsOpenDropdown("");
      setIsMessageFromJump(true);
      dispatch(setChatMessage(result));
    }
  };

  const handlePropagation = (e) => {
    e.stopPropagation();
  };

  const handleJumpToMessage = (value) => {
    if (value?.thread_id) {
      dispatch(
        setActiveThreadChat({
          documentID: value?.documentID,
          id: value?.parent_id,
        }),
      );
      dispatch(setJumpTargetMessageThread(value));
    } else {
      dispatch(setChatboardSelectedTab("messages"));
      dispatch(setJumpTargetMessage(value));
    }
  };

  const handlePinnedMessage = async (chatRow) => {
    const updatedEditableData = { ...chatRow };
    if (chatRow?.pinned) {
      updatedEditableData["pinned"] = false;
      updatedEditableData["pinned_by"] = "";
      updatedEditableData["pinned_timestamp"] = "";
    } else {
      updatedEditableData["pinned"] = true;
      updatedEditableData["pinned_by"] = senderID;
      updatedEditableData["pinned_timestamp"] = Date.now();
    }
    updatedEditableData["messageID"] = chatRow.id;
    await _sendPinnedChatMessage(updatedEditableData);
  };

  return (
    <>
      {progress !== "" && <ProgressBar progress={progress} />}
      {
        <>
          {chatboardSelectedTab === "pins" ? (
            <PinnedMessages
              handlePinnedMessage={handlePinnedMessage}
              handleJumpToMessage={handleJumpToMessage}
            />
          ) : chatboardSelectedTab === "files" ? (
            <ChatboardFiles />
          ) : chatboardSelectedTab === "thread" ? (
            <ChatboardThread />
          ) : chatboardSelectedTab === "search" ? (
            <ChatboardSearch handleJumpToMessage={handleJumpToMessage} />
          ) : chatboardSelectedTab === "messages" ? (
            loaderActiveData ? (
              <CustomChatLoader />
            ) : (
              <div
                ref={chatFeed}
                id="chat-feed"
                className={`chat-feed ${
                  chatMessageByGroup.length >= 5 && "overflow-auto"
                }  ${disableScroll ? "overflow-hidden" : ""}`}
                onScroll={(e) => !stopScrollBottom && handleScroll(e)}
              >
                {beginningMessage ? (
                  <BeginningOfChatMessage
                    username={
                      type === "private" ? username : attendeeData.groupName
                    }
                    type={type}
                  />
                ) : // : searchChatData != "" && newChatMessage.length === 0 ? (
                //   <ChatMessageNotFound />
                // )
                null}
                <div>{isFetchingChatHistory && <CustomChatLoader />}</div>
                <div>
                  {chatMessageByGroup?.map((chatItem, index) => {
                    if (chatItem?.thread_id) return null;

                    const value = { ...chatItem };
                    let message = value.message;
                    if (message?.includes("href=")) {
                      const newMessage = message.replace(
                        hrefPattern,
                        '<a href="' + hrefValue + '"',
                      );
                      value["message"] = newMessage;
                    }

                    return (
                      <Fragment key={index}>
                        {value.checkdate &&
                          !value.deleted &&
                          !deletedMessageIds.includes(value.id) && (
                            <div className="chat_row chat_row_hr">
                              <div className="top-border text-right mt-3 mb-1">
                                <div className="current-date-div">
                                  <div
                                    className="current-date-inner"
                                    onClick={(e) => handlePropagation(e)}
                                  >
                                    <a
                                      className="justify-content-center position-relative"
                                      type="button"
                                      onClick={(e) => {
                                        handleDisableScroll(e, value?.id);
                                      }}
                                      ref={(ref) =>
                                        (chatFilterRef.current[index] = ref)
                                      }
                                      id={value.id}
                                    >
                                      <small className="current-date">
                                        {value.checkdate == todayDate
                                          ? "Today"
                                          : value.checkdate}

                                        <DownChevronIcon
                                          className={"ml-2"}
                                          width={8}
                                        />
                                      </small>
                                      {value.id === selectedJumpId && (
                                        <CustomDropdown
                                          {...{
                                            handleChatFilterByDate,
                                            isOpenDropdown,
                                          }}
                                        />
                                      )}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                        {value.senderID === senderID ? (
                          <ChatBoardOutgoing
                            value={value}
                            userInfo={outgoingUserObj}
                            lastMessage={
                              chatMessageByGroup.length - 1 === index
                                ? true
                                : false
                            }
                            editMessageHandler={editMessageHandler}
                            messageEditId={messageEditId}
                            moreActionHandler={moreActionHandler}
                            moreActionEnableId={moreActionEnableId}
                            senderID={senderID}
                            replyHandler={replyHandler}
                            setMoreActionEnableId={setMoreActionEnableId}
                            setStopScrollBottom={setStopScrollBottom}
                            handlePinnedMessage={handlePinnedMessage}
                          />
                        ) : (
                          <ChatBoardIncoming
                            value={value}
                            userInfo={incomingUserObj}
                            lastMessage={
                              chatMessageByGroup.length - 1 === index
                                ? true
                                : false
                            }
                            moreActionHandler={moreActionHandler}
                            moreActionEnableId={moreActionEnableId}
                            senderID={senderID}
                            replyHandler={replyHandler}
                            setMoreActionEnableId={setMoreActionEnableId}
                            handlePinnedMessage={handlePinnedMessage}
                          />
                        )}
                      </Fragment>
                    );
                  })}
                </div>
                <div ref={lastElement}></div>
              </div>
            )
          ) : null}
        </>
      }
      {imagePreviewOpen && (
        <ImagePreview handleImagePreviewClose={handleImagePreviewClose} />
      )}
    </>
  );
};

export default memo(ChatBoardBody);

const BeginningOfChatMessage = memo(({ username, type }) => {
  return (
    <p className="text-center">
      {`This is the very beginning of ${
        type === "private" ? "your direct" : ""
      } messages ${type === "private" ? "with" : "in the group"}`}
      <span className="text-highlight">&nbsp;{username}&nbsp;</span>
    </p>
  );
});

// const ChatMessageNotFound = () => {
//   return (
//     <p className="text-center">
//       <b>{alertMsg.nothingSearch}</b>
//       <br />
//       {alertMsg.msgNotFound}
//       <br />
//     </p>
//   );
// };
